import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import RouterLinkButton from 'components/router-link-button'

const FreeTierLimitDialog = ({ open, setOpen, isPgaHopeCoach }) => {
  const title = isPgaHopeCoach
    ? 'Create PGA HOPE or Family Golf Event'
    : 'Create Family Golf Event'

  const content = isPgaHopeCoach
    ? 'You have reached your group offering limit on the starter tier. As a certified PGA HOPE coach, you can only create PGA HOPE or Family Golf events. For more event options, consider upgrading to a PGA Coach+.'
    : 'You have reached your group offering limit on the starter tier. You can only create Family Golf events. For more event options, consider upgrading to a PGA Coach+.'

  return (
    <Dialog open={open} maxWidth="xs" onClose={() => setOpen(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="textSecondary">
          {content}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color="primary">
          Cancel
        </Button>
        <RouterLinkButton
          variant="contained"
          color="primary"
          to="/pga-coach/bookings/events/new"
        >
          Create Event
        </RouterLinkButton>
      </DialogActions>
    </Dialog>
  )
}

export default FreeTierLimitDialog
